export function isFullScreen(): boolean {
  const isFullscreenMode =
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement;

  return !!isFullscreenMode; // Ensures the return value is true/false
}
